/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["known-for-widget{color:var(--be-secondary-text);font-size:1.3rem}known-for-widget .separator{padding:0 5px}"];
export { styles as styles };
